function week ()  {
let week =[];
for (let i = 1; i <=52; i++) {
  week.push(i)
}
return week
}
let weekNumberData = week();
export default weekNumberData;